<template>
<div>
    <el-table
        id="economic-sponsor"
        :data="tableData
            .filter(sponsor => sponsor.name.toLowerCase().includes(search.toLowerCase()) || sponsor.cnpj.cnpj.includes(unMaskedCnpjSearch))"
        :row-key="getRowKeys"
        ref="multipleTable"
        style="width: 100%"
        max-height="325"
        @selection-change="handleSelectionChange"
        @row-click="selectRow"
        :class="getPrimaryColor"
        @select-all="handleSelectAll"
    >

        <el-table-column
            :reserve-selection="true"
            type="selection"
            width="60"
            :selectable="(row) => !selection.length || selection.includes(row.id)"
        >
        </el-table-column>

        <el-table-column prop="name" label="financiador" min-width="110">
            <template slot-scope="scope">
                <span class="c-ndarkfour medium">
                    {{ scope.row.name | formatName }}
                </span>
            </template>
        </el-table-column>

        <el-table-column prop="cnpj" label="cnpj" min-width="80">
            <template slot-scope="scope">
                <span class="c-ndarkfour medium">
                    {{ scope.row.cnpj.cnpj | formatCnpjOrCpf }}
                </span>
            </template>
        </el-table-column>

        <el-table-column align="right" min-width="110">
            <template slot="header" slot-scope="scope">
                <SearchFilter :name="scope" v-model="searchInput" @search="filterSearchQuery"/>
            </template>
        </el-table-column>

        <div slot="empty">
            <NotFoundSponsorGroup />
        </div>

    </el-table>
</div>
</template>

<script>
import SearchFilter from '@/components/filters/SearchFilter'
import removeMask from '@/utils/removeMask'
import NotFoundSponsorGroup from '@/components/emptyOrNotFound/NotFoundSponsorGroup'

export default {
    components: {
        SearchFilter,
        NotFoundSponsorGroup
    },
    props: {
        tableData: {
            required: true
        },
        singleSelection: {
            required: false,
            default: false
        }
    },
    data() {
        return {
            getRowKeys(row) {
                return row.id
            },
            selection: [],
            search: '',
            searchInput: '',

        }
    },
    watch: {
        searchInput(val) {
            if (!val.length) {
                this.filterSearchQuery()
            }
        }
    },
    computed: {
        unMaskedCnpjSearch() {
            return removeMask(this.search)
        },
    },
    methods: {
        selectRow(row, column) {
            if (column.label) this.$refs.multipleTable.toggleRowSelection(row)
        },
        handleSelectionChange(sponsors) {
            const ids = sponsors.map(sponsor => sponsor.id)
            if (this.singleSelection) {
                this.selection = ids
            }
            this.$emit('change', ids)
            this.$store.commit('group/setSelectedSponsors', sponsors)
        },
        filterSearchQuery() {
            this.search = this.searchInput
        },
        handleSelectAll() {
            if (this.singleSelection) {
                this.$refs.multipleTable.clearSelection()
            }
        }

    },
    mounted() {
        if (this.$store.state.group.selectedSponsors.length) {
            this.$store.state.group.selectedSponsors.map(row => this.$refs.multipleTable.toggleRowSelection(row))
        }
    },
}
</script>

<style lang="scss">
</style>